// src/lib/surface-m2.js — MICRO-LOT « CHAMP SURFACE » (GO Dimitri 2026-08-01)
//
// Validation de la saisie admin « Surface (m²) » — carte 🏠 Caractéristiques
// du logement (Livret & Formulaires > Instructions), path cfg
// `capacity.surface_m2` (self-only comme les autres champs capacity, ADR-197 :
// pas d'héritage parent).
//
// Règles (helper pur, testé en Jest) :
//   - vide (ou espaces) → ACCEPTÉ, valeur `null` — champ facultatif : le
//     payload public OMET alors la surface (règle « rien plutôt que faux »)
//   - entier strictement positif (chiffres uniquement) → ACCEPTÉ (number)
//   - tout le reste (lettres, décimaux, négatif, 0) → REFUSÉ : la saisie est
//     ignorée par l'input contrôlé, le champ garde sa valeur précédente.

/**
 * Parse une saisie brute du champ « Surface (m²) ».
 *
 * @param {*} raw — valeur brute (string de l'input, ou number/null existant)
 * @returns {{ accepted: boolean, value: number|null }}
 *   accepted=false → saisie refusée (ne pas écrire le cfg) ;
 *   accepted=true  → écrire `value` (entier > 0, ou null si champ vidé).
 */
export function parseSurfaceM2Input(raw) {
  const s =
    typeof raw === "string" ? raw.trim() : raw == null ? "" : String(raw).trim()
  if (s === "") return { accepted: true, value: null }
  // Chiffres UNIQUEMENT : refuse lettres, signes, décimaux ("14.5", "-3", "1e2").
  if (!/^\d+$/.test(s)) return { accepted: false, value: null }
  const n = parseInt(s, 10)
  if (!Number.isFinite(n) || n <= 0) return { accepted: false, value: null }
  return { accepted: true, value: n }
}
